module.exports = __webpack_public_path__ + "img/whitepaper-bg.ee45dd83.webp";